<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}室安全管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-select v-model="formInline.region" placeholder="请选择组织结构">
            <el-option label="班级一" value="shanghai"></el-option>
            <el-option label="班级二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-input v-model="formInline.user" :placeholder="`请输入${$store.state.themeTitle}室名称`"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">录入准则</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="training_no" :label="`${$store.state.themeTitle}室编号`" width="120">
        </custom-table-column>
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="150">
        </custom-table-column>
        <custom-table-column prop="content" label="准则内容" min-width="200">
        </custom-table-column>
        <custom-table-column prop="username" label="录入人" width="140">
        </custom-table-column>
        <!-- <custom-table-column prop="phone" label="录入人电话" width="120">
        </custom-table-column>
        <custom-table-column prop="mail" label="邮箱" width="160">
        </custom-table-column> -->
        <!-- <custom-table-column prop="city" label="位置" width="220">
        </custom-table-column>
        <custom-table-column prop="sj" label="日期" width="155">
        </custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="准则信息" :visible.sync="centerDialogVisible" width="766px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_no">
          <el-select v-model="ruleForm.training_no" filterable style="width:216px;"
            :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安全准则" prop="content">
          <el-input type="textarea" v-model="ruleForm.content" placeholder="请输入安全准则" style="width:532px;"
            rows='3'></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitFormByFun('ruleForm', creatRule)">确认</el-button>
          <!-- <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateUser)">编辑</el-button> -->
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ delText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteRule">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageLine from '@/components/page.vue';
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'trainingRoom',
  mixins: [mixinList],
  data() {
    return {
      formInline: {
        user: '',
        region: '',
        date: '',
      },
      ruleForm: {
        training_no: '',
        training_name: '',
        content: '',
      },
      rules: {
        training_no: [{ required: true, message: `请输入${this.$store.state.themeTitle}室编号`, trigger: 'blur' }],
        training_name: [{ required: true, message: `请输入${this.$store.state.themeTitle}室名称`, trigger: 'blur' }],
        content: [{ required: true, message: '请输入安全准则', trigger: 'blur' }],
      },
      centerDialogVisible: false,
      total: 0,
      tableData: [],
    };
  },
  components: {
    PageLine,
  },
  created() {
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    this.$store.dispatch('getTarinMent');

  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async deleteRule() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteRule(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList();
      }
    },
    async creatRule() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // if (params.lesson_time) {
      //   let timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.creatRule(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = {
        page: this.$refs.pageChild.page,
        size: this.$refs.pageChild.size,
      };
      if (this.formInline.type || this.formInline.type == 0) {
        params.type = this.formInline.type;
      }
      if (this.formInline.name) {
        params.name = this.formInline.name;
      }
      if (this.formInline.number) {
        params.number = this.formInline.number;
      }
      let res = await this.$api.query.getSafes(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
